import axios from "axios";
axios.defaults.preflightContinue = true;
axios.defaults.crossDomain = true;
//axios.defaults.withCredentials = !!token;
axios.defaults.headers.common = {
  ...axios.defaults.headers.common,
  //"Access-Control-Allow-Origin": "//withtomatoseven.kr",
  //"Content-Type": "application/json;charset=UTF-8",
  //"Access-Control-Allow-Origin": "*",
  //"Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  //Accept: "application/json",
  //Authorization: "zaka",
};

const category_large = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/largeCategory.php",
    JSON.stringify(payload)
  );
};
const category_medium = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/mediumCategory.php",
    JSON.stringify(payload)
  );
};
const category_small = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/smallCategory.php",
    JSON.stringify(payload)
  );
};
const menu = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/menu.php",
    JSON.stringify(payload)
  );
};
const use_pers = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/use_pers.php",
    JSON.stringify(payload)
  );
};
const use_pers_grp = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/use_pers_grp.php",
    JSON.stringify(payload)
  );
};
const use_pers_grp_map = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/use_pers_grp_map.php",
    JSON.stringify(payload)
  );
};
const auth = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/auth.php",
    JSON.stringify(payload)
  );
};
const auth_grp = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/auth_grp.php",
    JSON.stringify(payload)
  );
};
const auth_menu_map = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/auth_menu_map.php",
    JSON.stringify(payload)
  );
};
const auth_use_pers_grp_map = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/auth_use_pers_grp_map.php",
    JSON.stringify(payload)
  );
};
const meteCode = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/meteCode.php",
    JSON.stringify(payload)
  );
};
const sysCode = (payload) => {
  return axios.post(
    "//withtomatoseven.kr/friends/sysCode.php",
    JSON.stringify(payload)
  );
};
export default {
  async category_large(payload) {
    try {
      const Response = await category_large(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async category_medium(payload) {
    try {
      const Response = await category_medium(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async category_small(payload) {
    try {
      const Response = await category_small(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async menu(payload) {
    try {
      const Response = await menu(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async use_pers(payload) {
    try {
      const Response = await use_pers(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async use_pers_grp(payload) {
    try {
      const Response = await use_pers_grp(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async use_pers_grp_map(payload) {
    try {
      const Response = await use_pers_grp_map(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth(payload) {
    try {
      const Response = await auth(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth_grp(payload) {
    try {
      const Response = await auth_grp(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth_menu_map(payload) {
    try {
      const Response = await auth_menu_map(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async auth_use_pers_grp_map(payload) {
    try {
      const Response = await auth_use_pers_grp_map(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async meteCode(payload) {
    try {
      const Response = await meteCode(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
  async sysCode(payload) {
    try {
      const Response = await sysCode(payload);
      return Response;
    } catch (err) {
      console.error(err);
    }
  },
};
